import React, { useEffect, useState } from 'react';
import ConfirmacionConTarjetaClub from '@images/confirmacionConTarjetaClub';
import { sendEventRUM } from '../Helpers/DataDog';
import { EventTrackAndLogData, PageViewTrackAndLogData } from '../Config/TrackAndLogData';
import ConfirmacionDetalle from '../Components/Common/banner/ConfirmacionDetalle';
import ConfirmacionLogin from '../Components/Common/login/src/confirmacion/ConfirmacionLogin';
import LoadingSpinner from './../Helpers/LoadingSpinner';
import useObtenerEventosSuscripcionesOnDemand from '../Hooks/useObtenerEventosOnDemand';

const Confirmacion = ({ state }) => {
    const conClubLN = state.context.datosCarrito?.tieneClub;
    const crmId = state.context.dataVenta.ventaResponse.CrmId.trim();
    const [evento, errorEvento, isLoadingEventos] = useObtenerEventosSuscripcionesOnDemand(crmId);

    useEffect(() => {
        PageViewTrackAndLogData('pagina_confirmacion', state.context.planCampania.descripcion);
        window.history.pushState({ page: 'checkout' }, 'checkout');

        window.addEventListener('popstate', handleBtnBackPressed);

        return () => {
            window.removeEventListener('popstate', handleBtnBackPressed);
        };
    }, []);

    const handleBtnBackPressed = () => {
        window.location = `${process.env.REACT_APP_LNREDIRECT}`;
    };

    const handleClickFinalizar = () => {
        EventTrackAndLogData('finaliza-flujo');
        sendEventRUM('Finaliza flujo');
        window.location = `${process.env.REACT_APP_LNREDIRECT}`;
    };

    return (
        <>
            <LoadingSpinner isLoading={isLoadingEventos}>
                {conClubLN ? (
                    <ConfirmacionLogin
                        titleText={'¡Gracias por suscribirte!'}
                        image={<ConfirmacionConTarjetaClub width="201.24" height="160" />}
                        firstBtnLabel={'volver a la nacion'}
                        firstBtnOnClick={handleClickFinalizar}
                        showCallbackArticle={false}
                        secondBtnLabel={'IR A CLUB LA NACION'}
                        secondBtnOnClick={() => (window.location = `https://club.lanacion.com.ar/`)}
                    >
                        <ConfirmacionDetalle tieneClubLN={conClubLN} />
                    </ConfirmacionLogin>
                ) : (
                    <ConfirmacionLogin
                        titleText={'¡Gracias por suscribirte!'}
                        image={<ConfirmacionConTarjetaClub width="201.24" height="160" />}
                        firstBtnLabel={'volver a la nacion'}
                        firstBtnOnClick={handleClickFinalizar}
                        showCallbackArticle={false}
                    >
                        <ConfirmacionDetalle tieneClubLN={conClubLN} />
                    </ConfirmacionLogin>
                )}
            </LoadingSpinner>
        </>
    );
};

export default Confirmacion;
